<form *ngIf="sockGeneralDetails" [formGroup]="sockGeneralDetails" (keydown.control.enter)="onCtrlEnter()">
  <div class="w-full xl:flex items-stretch bg-[#F7F5FF] border border-t-0 border-[#D9F8F9] rounded-b-sm py-6">
    <div class="w-full xl:w-[84%] mb-3 xl:mb-0 xl:border-r border-r-[#d9d9d9]">
      <div
        class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 2xl:grid-cols-6 gap-2 sm:gap-2.5 lg:gap-3 px-3 space-y-0.5">
        <!-- Type is always visible because it is a required field -->
        <div class="col-span-1">
          <div class="relative">
            <input type="text" id="type" formControlName="type" (input)="onTypeInputChange($event)" autocomplete="off"
              (keydown)="onKeyDown($event)" (focus)="onFocusType()" (blur)="onBlurType()" [attr.autocomplete]="'off'"
              #typeInput
              class="peer capitalize block pl-2 pr-6 py-2 w-full text-sm text-[#444] font-normal bg-white rounded-md border border-dcdcdc appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-[#c19725]"
              placeholder=" " />
            <ul *ngIf="showDropdown && filteredStockTypes?.length > 0"
              class="absolute z-10 bg-white w-full max-h-100 overflow-y-auto shadow-md rounded-md mt-1">
              <li *ngFor="let t of filteredStockTypes; let i = index" (mousedown)="selectingFromDropdown = true"
                (click)="selectFilteredType(t)" [ngClass]="{
                  'bg-gray-200': i === highlightedIndex,
                  'hover:bg-gray-100': i !== highlightedIndex
                }" class="px-2 py-0.5 capitalize text-sm text-[#444] font-normal cursor-pointer">
                {{ t }}
              </li>
            </ul>
            <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
              <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
              </svg>
            </div>
            <label for="type"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Type <span class="text-red-500">*</span>
            </label>
          </div>
          <div *ngIf="
              sockGeneralDetails.get('type')?.touched &&
              sockGeneralDetails.get('type')?.invalid
            " class="text-red-500 text-xs mt-1">
            <span *ngIf="sockGeneralDetails.get('type')?.errors?.['required']">Type is required</span>
            <span *ngIf="sockGeneralDetails.get('type')?.errors?.['maxlength']">Maximum 100 characters allowed</span>
          </div>
        </div>

        <!-- <div class="col-span-1" *ngIf="isVisible('group')">
          <div class="relative">
            <input type="text" id="group" formControlName="group" (keydown.enter)="focusNext($event)" autocomplete="off" (input)="onGroupInputChange($event)" (keydown)="onGroupKeyDown($event)" (focus)="onFocusGroup()" (blur)="onBlurGroup()" [attr.autocomplete]="'off'" #groupInput class="block px-2 py-2 w-full text-sm lg:text-sm text-[#444] font-normal bg-white rounded-md border border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer" placeholder=" " />
            <ul *ngIf="showGroupDropdown && filteredGroups?.length > 0" class="absolute z-10 bg-white w-full max-h-100 overflow-y-auto shadow-md rounded-md mt-1">
              <li *ngFor="let g of filteredGroups; let i = index" (mousedown)="selectingGroupFromDropdown = true" (mousedown)="selectFilteredGroup(g); onGroupChange(g)" [class.bg-gray-100]="i === selectedGroupIndex" class="px-2 py-0.5 capitalize text-sm text-[#444] font-normal hover:bg-gray-100 cursor-pointer">
                {{ g }}
              </li>
            </ul>
            <label for="group" class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Group <span class="text-red-500">*</span>
            </label>
          </div>
          <div *ngIf="sockGeneralDetails.get('group')?.touched && sockGeneralDetails.get('group')?.invalid" class="text-red-500 text-xs mt-1">
            <span *ngIf="sockGeneralDetails.get('group')?.errors?.['required']">*Group is required</span>
            <span *ngIf="sockGeneralDetails.get('group')?.errors?.['maxlength']">*Maximum 100 characters allowed</span>
          </div>
        </div> -->

        <div class="col-span-1" *ngIf="isVisible('category_id')">
          <div class="relative">
            <input readonly type="hidden" formControlName="category_id" />
            <input readonly type="text" [value]="typedCategory" id="category_id" (keydown.enter)="focusNext($event)"
              autocomplete="off" [class.grey-text]="typedCategoryReadonly"
              (input)="!typedCategoryReadonly && onCategoryInputChange($event)" (keydown)="onCategoryKeyDown($event)"
              (focus)="!typedCategoryReadonly && onCategoryFocus()" (blur)="!typedCategoryReadonly && onCategoryBlur()"
              [attr.autocomplete]="'off'" #categoryInputRef
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="category_id"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Category <span class="text-red-500">*</span>
            </label>
            <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
              <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
              </svg>
            </div>
            <ul *ngIf="showCategoryDropdown && filteredCategories.length > 0"
              class="absolute z-10 bg-white w-full max-h-100 overflow-y-auto shadow-md rounded-md mt-1">
              <li *ngFor="let category of filteredCategories; let i = index" (mousedown)="selectCategory(category)"
                [ngClass]="{
                  'bg-gray-200': i === highlightedCategoryIndex,
                  'hover:bg-gray-100': i !== highlightedCategoryIndex
                }" class="px-2 py-0.5 capitalize text-sm text-[#444] font-normal cursor-pointer">
                {{ category.name }} <span class="text-c19725">(#{{ category.unit }})</span>
              </li>
            </ul>
          </div>
          <div *ngIf="
              sockGeneralDetails.get('category_id')?.touched &&
              sockGeneralDetails.get('category_id')?.invalid
            " class="text-red-500 text-xs mt-1">
            <span *ngIf="sockGeneralDetails.get('category_id')?.errors?.['required']">*Category is required</span>
          </div>
        </div>

        <!-- Category Code (auto-filled readonly) -->
        <div class="col-span-1">
          <div class="relative">
            <input readonly type="text" formControlName="category_code"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-gray-50 rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 peer"
              placeholder=" " />
            <label
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-gray-50 px-1.5 start-1">
              Category Code
            </label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('model_number')">
          <div class="relative">
            <input type="text" id="model_number" formControlName="model_number" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="model_number"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Model
              Number <span class="text-red-500">*</span></label>
          </div>
          <div *ngIf="
              sockGeneralDetails.get('model_number')?.invalid &&
              (sockGeneralDetails.get('model_number')?.dirty ||
                sockGeneralDetails.get('model_number')?.touched)
            " class="text-red-500 text-xs mt-1">
            <div *ngIf="
                sockGeneralDetails.get('model_number')?.touched &&
                sockGeneralDetails.get('model_number')?.invalid
              ">
              <span *ngIf="sockGeneralDetails.get('model_number')?.errors?.['required']">*Model Number is
                required</span>
              <span *ngIf="sockGeneralDetails.get('model_number')?.errors?.['maxlength']">*Maximum 100 characters
                allowed</span>
            </div>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('unique_code_sku')">
          <div class="relative">
            <input type="text" id="unique_code_sku" formControlName="unique_code_sku" autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="unique_code_sku"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Product
              SKU/ Unique Code
              <span class="text-red-500">*</span></label>
          </div>
          <div *ngIf="
              sockGeneralDetails.get('unique_code_sku')?.touched &&
              sockGeneralDetails.get('unique_code_sku')?.invalid
            " class="text-red-500 text-xs mt-1">
            <span *ngIf="sockGeneralDetails.get('unique_code_sku')?.errors?.['required']">*Unique Code / SKU is
              required</span>
            <span *ngIf="sockGeneralDetails.get('unique_code_sku')?.errors?.['maxlength']">*Maximum 100 characters
              allowed</span>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <select id="brand_name" formControlName="brand_name" (keydown.enter)="focusNext($event)" class="block w-full px-3 py-2 pr-8 text-sm text-444 bg-white
                  border border-dcdcdc rounded-md appearance-none
                  focus:outline-none focus:ring-0 focus:border-c19725">
              <!-- Placeholder option -->
              <option value="" disabled hidden>
                Select Brand
              </option>

              <option *ngFor="let brand of brandList" [value]="brand.id">
                {{ brand.assembly_brand_name }}
              </option>
            </select>

            <!-- Label (select-safe floating style) -->
            <label for="brand_name" class="absolute -top-2 left-2 bg-white px-1 text-xs text-[#898989]">
              Brand Name
            </label>

            <!-- Dropdown arrow -->
            <div class="pointer-events-none absolute inset-y-0 right-2 flex items-center">
              <svg class="w-4 h-4 text-[#898989]" fill="none" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </div>


        <div class="col-span-1" *ngIf="isVisible('supplier_code')">
          <div class="relative">
            <input type="text" id="supplier_code" formControlName="supplier_code" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="supplier_code"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Supplier
              Code</label>
          </div>
        </div>

        <!-- <div class="col-span-1" *ngIf="isVisible('sub_category_id')">
          <div class="relative">
            <input type="hidden" formControlName="sub_category_id" />
            <input type="text" [value]="typedSubCategory" id="sub_category" (keydown.enter)="focusNext($event)" autocomplete="off" [class.grey-text]="typedSubCategoryReadonly" (input)="!typedSubCategoryReadonly && onSubCategoryInputChange($event)" (keydown)="onSubCategoryKeydown($event)" (focus)="!typedSubCategoryReadonly && onSubCategoryFocus()" (blur)="!typedSubCategoryReadonly && onSubCategoryBlur()" [attr.autocomplete]="'off'" #subCategoryInputRef class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" placeholder=" " />
            <label for="sub_category" class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Sub Category
            </label>
            <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
              <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
              </svg>
            </div>
            <ul *ngIf="showSubCategoryDropdown && filteredSubCategories.length > 0" class="absolute z-10 bg-white w-full max-h-100 overflow-y-auto shadow-md rounded-md mt-1">
              <li *ngFor="let sub of filteredSubCategories; let i = index" (mousedown)="selectSubCategory(sub)" [ngClass]="{ 'bg-gray-200': i === highlightedSubIndex, 'hover:bg-gray-100': i !== highlightedSubIndex }" class="px-2 py-0.5 capitalize text-sm text-[#444] font-normal cursor-pointer">
                {{ sub.name }}
              </li>
            </ul>
          </div>
        </div> -->

        <div class="col-span-1" *ngIf="isVisible('product_name')">
          <div class="relative">
            <input type="text" id="product_name" (keydown.enter)="focusNext($event)" formControlName="product_name"
              autocomplete="off"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="product_name"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Product
              Name </label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('hsn_code')">
          <div class="relative">
            <input type="text" id="hsn_code" [class.grey-text]="isReadOnly('hsn_code')" formControlName="hsn_code"
              autocomplete="off" (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="hsn_code"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">HSN
              Code</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('metal_type')">
          <div class="relative">
            <input type="text" id="metal_type" [class.grey-text]="isReadOnly('metal_type')" autocomplete="off"
              (keydown)="onMetalTypeKeydown($event)" (keydown.enter)="focusNext($event)" formControlName="metal_type"
              (input)="onMetalTypeInputChange($event)" (focus)="onFocusMetalType()" (blur)="onBlurMetalType()"
              [attr.autocomplete]="'off'" #metalTypeInput
              class="peer block px-2 py-2 w-full text-sm text-[#444] font-normal bg-white rounded-md border border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725]"
              placeholder=" " />
            <ul *ngIf="showMetalDropdown && filteredMetalTypes?.length > 0"
              class="absolute z-10 bg-white w-full max-h-100 overflow-y-auto shadow-md rounded-md mt-1"
              aria-label="metal-type-dropdown">
              <li *ngFor="let m of filteredMetalTypes; let i = index" (mousedown)="selectingMetalFromDropdown = true"
                (click)="selectFilteredMetalType(m)" [class.bg-gray-100]="highlightedMetalIndex === i"
                class="px-2 py-0.5 capitalize text-sm text-[#444] font-normal hover:bg-gray-100 cursor-pointer">
                {{ m }}
              </li>
            </ul>
            <label for="metal_type"
              class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
              Product/Metal Type <span class="text-red-500">*</span>
            </label>
            <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
              <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
              </svg>
            </div>
          </div>
          <div *ngIf="
              sockGeneralDetails.get('metal_type')?.touched &&
              sockGeneralDetails.get('metal_type')?.invalid
            " class="text-red-500 text-xs mt-1">
            <span *ngIf="sockGeneralDetails.get('metal_type')?.errors?.['required']">*Metal Type is required</span>
            <span *ngIf="sockGeneralDetails.get('metal_type')?.errors?.['maxlength']">*Maximum 100 characters
              allowed</span>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('purity')">
          <div class="relative">
            <input type="number" appOnlyNumber id="purity" formControlName="purity" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="purity"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Purity</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('stamp')">
          <div class="relative">
            <input type="text" id="stamp" formControlName="stamp" (keydown.enter)="focusNext($event)" autocomplete="off"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="stamp"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Stamp
            </label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('clarity')">
          <div class="relative">
            <input type="text" id="clarity" formControlName="clarity" (input)="onClarityInputChange($event)"
              autocomplete="off" (focus)="onFocusClarity()" (blur)="onBlurClarity()"
              (keydown)="onClarityKeydown($event)" (keydown.enter)="focusNext($event)" [attr.autocomplete]="'off'"
              #clarityInput
              class="block px-2 py-2 w-full text-sm text-[#444] font-normal bg-white rounded-md border border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
              placeholder=" " />
            <ul *ngIf="showClarityDropdown && filteredClarities?.length > 0"
              class="absolute z-10 bg-white w-full max-h-100 overflow-y-auto shadow-md rounded-md mt-1">
              <li *ngFor="let c of filteredClarities; let i = index" [class.bg-gray-100]="highlightedClarityIndex === i"
                (mousedown)="onDropdownMouseDown()" (click)="selectFilteredClarity(c)"
                class="px-2 py-0.5 capitalize text-sm text-[#444] font-normal hover:bg-gray-100 cursor-pointer">
                {{ c }}
              </li>
            </ul>
            <label for="clarity"
              class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
              Clarity
            </label>
            <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
              <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
              </svg>
            </div>
          </div>
        </div>

        <div class="col-span-2 sm:col-span-2 md:col-span-2" *ngIf="isVisible('conversion')">
          <div class="w-full flex items-center">
            <div class="relative">
              <input type="number" disabled id="" autocomplete="off"
                class="cursor-not-allowed block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-[#FAFAFA] rounded-l-md border-1 border-r-0 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-dcdcdc peer"
                placeholder=" " />
            </div>
            <div class="relative grow">
              <input type="number" id="conversion" formControlName="conversion" (keydown.enter)="focusNext($event)"
                autocomplete="off"
                class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                placeholder=" " />
              <label for="conversion"
                class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Conversion</label>
            </div>
            <div class="relative">
              <input type="text" disabled id="" autocomplete="off"
                class="cursor-not-allowed block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-[#FAFAFA] rounded-r-md border-1 border-l-0 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-dcdcdc peer"
                placeholder=" " />
            </div>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('unit')">
          <app-custom-select label="Unit" [options]="unitTypes" formControlName="unit" [(selected)]="selectedUnits"
            selectId="unitTypes" (keydown.enter)="focusNext($event)">
          </app-custom-select>
        </div>

        <div class="col-span-1" *ngIf="isVisible('subunit')">
          <app-custom-select label="Sub Unit" [options]="subunitTypes" formControlName="subunit"
            [(selected)]="selectedSubunits" selectId="subunitTypes" (keydown.enter)="focusNext($event)">
          </app-custom-select>
        </div>

        <div class="col-span-1" *ngIf="isVisible('size')">
          <div class="relative">
            <input type="text" id="size" formControlName="size" (keydown.enter)="focusNext($event)" autocomplete="off"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="size"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Size</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('length')">
          <div class="relative">
            <input type="number" id="length" formControlName="length" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="length"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Length</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('width')">
          <div class="relative">
            <input type="number" id="width" formControlName="width" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="width"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Width</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('height')">
          <div class="relative">
            <input type="number" id="height" formControlName="height" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="height"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Height</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('color')">
          <div class="relative">
            <input type="text" id="color" formControlName="color" (keydown.enter)="focusNext($event)" autocomplete="off"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="color"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Color</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('gender')">
          <app-custom-select label="Gender" [options]="genderTypes" formControlName="gender"
            [(selected)]="selectedGender" selectId="genderTypes" (keydown.enter)="focusNext($event)">
          </app-custom-select>
        </div>

        <div class="col-span-1" *ngIf="isVisible('labour_charges')">
          <div class="relative">
            <input type="number" id="labour_charges" formControlName="labour_charges" autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="labour_charges"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Labour
              Charges</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('making_charges')">
          <div class="relative">
            <input type="number" id="making_charges" formControlName="making_charges" autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="making_charges"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Making
              Charges</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('making_charges_unit')">
          <app-custom-select label="Unit" [options]="makingChargUnits" formControlName="making_charges_unit"
            [(selected)]="selectedMaking" selectId="makingChargUnits" (keydown.enter)="focusNext($event)">
          </app-custom-select>
        </div>

        <div class="col-span-1" *ngIf="isVisible('thread_weight')">
          <div class="relative">
            <input type="number" id="thread_weight" formControlName="thread_weight" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="thread_weight"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Thread
              WT</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('total_thread_price')">
          <div class="relative">
            <input type="number" id="total_thread_price" formControlName="total_thread_price" autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="total_thread_price"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Total
              Thread Price</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('actual_weight')">
          <div class="relative">
            <input type="number" id="actual_weight" formControlName="actual_weight" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="actual_weight"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Actual
              Weight</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('min_weight')">
          <div class="relative">
            <input type="number" id="min_weight" formControlName="min_weight" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="min_weight"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Min
              weight</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('max_weight')">
          <div class="relative">
            <input type="number" id="max_weight" formControlName="max_weight" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="max_weight"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Max
              weight</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('min_size')">
          <div class="relative">
            <input type="number" id="min_size" formControlName="min_size" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="min_size"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Min
              Size</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('max_size')">
          <div class="relative">
            <input type="number" id="max_size" formControlName="max_size" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="max_size"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Max
              Size</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('sell_dis_code')">
          <div class="relative">
            <input type="text" id="sell_dis_code" formControlName="sell_dis_code" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="sell_dis_code"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Sell
              Disc Code</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('min_disc')">
          <div class="relative">
            <input type="number" id="min_disc" formControlName="min_disc" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="min_disc"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Min
              Disc</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('max_disc')">
          <div class="relative">
            <input type="number" id="max_disc" formControlName="max_disc" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="max_disc"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Max
              Disc</label>
          </div>
        </div>

        <div class="col-span-1" *ngIf="isVisible('disc_type')">
          <app-custom-select label="Dis Type" [options]="discountTypes" formControlName="disc_type"
            [(selected)]="selectedDiscounts" selectId="discountTypes" (keydown.enter)="focusNext($event)">
          </app-custom-select>
        </div>

        <div class="col-span-2 sm:col-span-3 lg:col-span-4" *ngIf="isVisible('description')">
          <div class="relative">
            <input type="text" id="description" formControlName="description" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="description"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Product
              Description</label>
          </div>
        </div>
      </div>
    </div>

    <!-- upload product images -->
    <div class="w-full xl:w-[16%] px-3">
      <p class="font-medium text-sm xl:text-base text-444 capitalize mb-3">
        Upload Product Images
      </p>
      <div class="grid grid-cols-2 sm:grid-cols-5 xl:grid-cols-2 gap-3">
        <div class="col-span-2 sm:col-span-1 md:col-span-1 xl:col-span-2">
          <div class="bg-white border border-[#D9D9D9] rounded-lg overflow-hidden">
            <label for="image1" class="cursor-pointer">
              <img class="w-full h-32 sm:h-auto xl:h-32 object-contain" [src]="imagePreviews[0]" alt="left logo" />
            </label>
            <input id="image1" type="file" accept="image/*" (change)="onImageSelected($event, 0)" class="hidden"
              autocomplete="off" />
          </div>
          <div *ngIf="fileUploadError[0]" class="text-red-500 text-xs mt-1">
            {{ fileUploadError[0] }}
          </div>
        </div>

        <div class="col-span-1">
          <div class="bg-white border border-[#D9D9D9] rounded-lg overflow-hidden aspect-square">
            <label for="image2" class="cursor-pointer w-full h-full block">
              <img class="w-full h-full object-contain" [src]="imagePreviews[1]" alt="left logo" />
            </label>
            <input id="image2" type="file" accept="image/*" (change)="onImageSelected($event, 1)" class="hidden" />
          </div>
          <div *ngIf="fileUploadError[1]" class="text-red-500 text-xs mt-1">
            {{ fileUploadError[1] }}
          </div>
        </div>

        <div class="col-span-1">
          <div class="bg-white border border-[#D9D9D9] rounded-lg overflow-hidden aspect-square">
            <label for="image3" class="cursor-pointer w-full h-full block">
              <img class="w-full h-full object-contain" [src]="imagePreviews[2]" alt="left logo" />
            </label>
            <input id="image3" type="file" accept="image/*" (change)="onImageSelected($event, 2)" class="hidden"
              autocomplete="off" />
          </div>
          <div *ngIf="fileUploadError[2]" class="text-red-500 text-xs mt-1">
            {{ fileUploadError[2] }}
          </div>
        </div>

        <div class="col-span-1">
          <div class="bg-white border border-[#D9D9D9] rounded-lg overflow-hidden aspect-square">
            <label for="image4" class="cursor-pointer w-full h-full block">
              <img class="w-full h-full object-contain" [src]="imagePreviews[3]" alt="left logo" />
            </label>
            <input id="image4" type="file" accept="image/*" (change)="onImageSelected($event, 3)" class="hidden"
              autocomplete="off" />
          </div>
          <div *ngIf="fileUploadError[3]" class="text-red-500 text-xs mt-1">
            {{ fileUploadError[3] }}
          </div>
        </div>

        <div class="col-span-1">
          <div class="bg-white border border-[#D9D9D9] rounded-lg overflow-hidden aspect-square">
            <label for="image5" class="cursor-pointer w-full h-full block">
              <img class="w-full h-full object-contain" [src]="imagePreviews[4]" alt="left logo" />
            </label>
            <input id="image5" type="file" accept="image/*" (change)="onImageSelected($event, 4)" class="hidden"
              autocomplete="off" />
          </div>
          <div *ngIf="fileUploadError[4]" class="text-red-500 text-xs mt-1">
            {{ fileUploadError[4] }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- buttons -->
  <div class="flex items-center justify-center mt-4 md:mt-8 space-x-1.5 md:space-x-4">
    <button type="button"
      class="size-6 md:size-9 block cursor-pointer capitalize p-1 md:p-1.5 text-base xl:text-lg font-bold text-c19725 bg-white border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
      <svg class="size-3 xl:size-4 mx-auto" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.1123 20L0.112305 10L10.1123 0L11.8873 1.775L3.6623 10L11.8873 18.225L10.1123 20Z" fill="#C19725" />
      </svg>
    </button>
    <button type="button" (click)="clearForm()"
      class="block cursor-pointer capitalize w-[110px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-c19725 bg-white border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
      Clear
    </button>

    <ng-container *ngIf="submitButton">
      <button type="button" id="submit" *ngIf="isVisible('submit')" (click)="submitAndClear()"
        class="block cursor-pointer capitalize w-[110px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
        Submit
      </button>
    </ng-container>

    <button type="button" *ngIf="submitButton" (click)="onSubmit()"
      class="block cursor-pointer capitalize w-[140px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
      Save<svg class="inline mx-1 sm:mx-2" width="12" height="13" viewBox="0 0 12 13" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M9.13125 7.25H0V5.75H9.13125L4.93125 1.55L6 0.5L12 6.5L6 12.5L4.93125 11.45L9.13125 7.25Z"
          fill="#ffffff" />
      </svg>
      Next
    </button>
    <button type="button" *ngIf="updateButton" (click)="editProduct()"
      class="block cursor-pointer capitalize w-[110px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
      Update
    </button>
    <button type="button"
      class="size-6 md:size-9 block cursor-pointer capitalize p-1 md:p-1.5 text-base xl:text-lg font-bold text-c19725 bg-white border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
      <svg (click)="goToAssemblyMetalPartsTab()" class="size-3 xl:size-4 mx-auto" viewBox="0 0 12 20" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M1.8877 20L11.8877 10L1.8877 0L0.112695 1.775L8.3377 10L0.112695 18.225L1.8877 20Z" fill="#C19725" />
      </svg>
    </button>
  </div>
</form>

<div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
  <table
    class="w-full table border border-b-0 border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden mt-10">
    <tbody *ngIf="newlyCreatedProduct">
      <tr>
        <td colspan="5" class="p-4">
          <div class="bg-white rounded-xl p-4 border border-gray-200">
            <h2 class="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
              <svg class="w-6 h-6 text-yellow-500" fill="none" stroke="currentColor" stroke-width="1.5"
                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M11.25 3.375L2.25 9.75l9 6.375 9-6.375-9-6.375zM2.25 14.25l9 6.375 9-6.375" />
              </svg>
              Product Details
            </h2>
            <div class="flex flex-wrap gap-x-16 gap-y-4 text-gray-700">
              <div class="flex items-center space-x-2">
                <span class="font-semibold text-gray-600">🔍 Model Number:</span>
                <span class="text-gray-900">{{
                  newlyCreatedProduct.model_number
                  }}</span>
              </div>
              <div class="flex items-center space-x-2">
                <span class="font-semibold text-gray-600">🏷️ Product Name:</span>
                <span class="text-gray-900">{{
                  newlyCreatedProduct.product_name
                  }}</span>
              </div>
              <div class="flex items-center space-x-2">
                <span class="font-semibold text-gray-600">📂 Type:</span>
                <span class="text-gray-900">{{
                  newlyCreatedProduct.type
                  }}</span>
              </div>
              <div class="flex items-center space-x-2">
                <span class="font-semibold text-gray-600">🔖 SKU:</span>
                <span class="text-gray-900">{{
                  newlyCreatedProduct.unique_code_sku
                  }}</span>
              </div>
              <div class="flex items-center space-x-2">
                <span class="font-semibold text-gray-600">🧾 HSN Code:</span>
                <span class="text-gray-900">{{
                  newlyCreatedProduct.hsn_code
                  }}</span>
              </div>
              <div class="flex items-center space-x-2">
                <span class="font-semibold text-gray-600">🏷️ Brand:</span>
                <span class="text-gray-900">{{
                  newlyCreatedProduct.brand_name
                  }}</span>
              </div>
              <div class="flex items-center space-x-2">
                <span class="font-semibold text-gray-600">👥 Group:</span>
                <span class="text-gray-900">{{
                  newlyCreatedProduct.group
                  }}</span>
              </div>
              <div class="flex items-center space-x-2">
                <div class="flex items-center justify-center gap-2 xl:gap-4">
                  <button class="cursor-pointer">
                    <svg (click)="
                        patchCurrentValuesForEdit(newlyCreatedProduct.id)
                      " class="size-5 lg:size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                        stroke="#C19725" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M14.7166 9.23962L8.10638 15.8499" stroke="#C19725" stroke-miterlimit="5"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                  <button class="cursor-pointer">
                    <svg (click)="deleteGeneralProduct(newlyCreatedProduct.id)" class="size-5 lg:size-6"
                      viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M14 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M4 7.5H20" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                        stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                        stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>